export default "__VITE_ASSET__c066d631__"